import axios from "axios";
import { toast } from "react-toastify";
import { ItemsDeleteApi, BudgetApi, PoRaisedItemApi } from ".";

export const deleteBudgetItems = ({ item_list, sub_item_list }) => {
  return axios
    .post(`${ItemsDeleteApi}`, {
      item_list: item_list ?? [],
      sub_item_list: sub_item_list ?? [],
    })
    .then((res) => {
      toast.success("Items deleted successfully");
    })
    .catch(() => {
      toast.error("Something went wrong!");
    });
};

export const fetchItemPoDetails = ({ item_id }) => {
  return axios
    .get(`${PoRaisedItemApi}?item=${item_id}`)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};

export const fetchItemDetails = ({ item_id }) => {
  return axios
    .get(`${BudgetApi}${item_id}`)
    .then((res) => {
      return res?.data;
    })
    .catch(() => {});
};
